<section class="detect-type my-5">
  <div class="container">
    <div class="row justify-content-center align-items-center d-flex">
      <div class="col-lg-8 m-auto">
        <h4 class="fw-semibold p-1 fw-bold text-center mb-5">Join as a User or Service provider</h4>
        <div class="row my-5">
          @for (item of types; track $index) {
            <div class="col-md-6">
              <div
                class="card mb-3 detect-type-card"
                [ngClass]="{ active: type === item.type }"
                (click)="selectType(item)"
              >
                <div class="card-body p-4">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <img [src]="item.img" alt="" class="mb-3" width="40" height="40" />
                    <div
                      class="check-box"
                      [ngStyle]="{
                        border: type === item.type ? '2px solid #3349b2' : 'none',
                      }"
                    >
                      <input type="radio" class="custom-check" [checked]="type === item.type" />
                    </div>
                  </div>
                  <h6 class="fw-bold mb-2">{{ item.name }}</h6>
                  <p class="text-dark">
                    {{ item.desc }}
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-lg-6 m-auto">
            <button
              class="btn btn-default w-100 fw-semibold"
              [disabled]="!type"
              type="button"
              (click)="routerToRegister()"
            >
              Continue
            </button>
            <div class="text-center my-3">
              <span class="text-black"> Already have an account? </span>
              <a
                href="javascript:void(0)"
                class="text-default fw-bold underscore-link text-decoration-none"
                [routerLink]="['/auth/login']"
              >
                Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
